export const generateRandomNumber = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min)
};

export const generateRandomOperator = (operators) => {
  const randomNumber = Math.floor(Math.random() * ((operators.length - 1) - 0 + 1) + 0);
  return operators[randomNumber];
};

export const roundToNearestWholeNumber = (value) => {
  return Math.round(value);
}